import { createStore } from "vuex";

import state from "./state.js";
import * as getters from "./getters.js";
import * as mutations from "./mutations.js";
import * as actions from "./actions.js";

export default createStore({
  state,
  mutations,
  actions,
  getters,
  // modules: {
  // }
});
